import { modifyPointCloud } from "api/timeline";
import { getPointCloudData } from "pages/unity/domain/getPointCloudData";

const colorDropdownConfig = {
  modifyPointCloud,
  getPointCloudData
};

export default colorDropdownConfig;